module.exports = __webpack_public_path__ + "img/logo.66381d86.png";